<ng-container *ngIf="profileConfig">
  <div class="amadeus-direct-style" *ngIf="profileState$ | async as profile">
    <ng-container *ngIf="customerConfig$ | async as customer">
      <ng-container *ngIf="profile.isLoading || customer.isLoading">
        <spinner fixed="true"></spinner>
      </ng-container>
      <div class="business-content profile-wrap">
        <ng-container *ngIf="profileForm">
          <form [formGroup]="profileForm" name="formUserEdit" id="formUserEdit">
            <div class="clearfix">
              <div class="row">
                <div class="mb-7 col-xl-2 col-md-4 col-sm-6 col-12">
                  <label for="userTitle">
                    <span i18n="@@profile-page.profileFormTitle">Title</span>
                    <span class="mandatory-indicator"aria-hidden="true">*</span>
                  </label>
                  <ng-select id="userTitle"
                             [searchable]="false"
                             [clearable]="false"
                             [items]="userTitles"
                             bindLabel="label"
                             bindValue="value"
                             (change)="processPlaceholders()"
                             [placeholder]="noTitlePlaceholder"
                             formControlName="name_title_option"
                             [ngClass]="showValidation && 
                              profileForm.get('name_title_option').invalid ? 'select-invalid' : ''">
                  </ng-select>
                  <div *ngIf="showValidation && profileForm.get('name_title_option').errors"
                       class="invalid-feedback"
                       i18n="@@profile-page.selectOneOfTheOptions">
                    Please select one of the options
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="mb-7 with-text-tip col-md-4 col-sm-6 col-12">
                  <label for="firstName"
                         class="form-label">
                    <span i18n="@@profile-page.profileFormFirstName">First name</span>
                    <span class="mandatory-indicator" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    formControlName="firstname"
                    class="form-control"
                    [class.is-invalid]="showValidation && profileForm.get('firstname').errors"
                    maxlength="50"
                  />
                  <ng-container *ngIf="showValidation && profileForm.get('firstname').errors">
                    <div
                      *ngIf="profileForm.get('firstname').errors.required"
                      class="invalid-feedback"
                      i18n="@@profile-page.profileMustBeNotEmpty"
                    >
                      Please fill in required field
                    </div>
                    <div
                      *ngIf="profileForm.get('firstname').value.length"
                      class="invalid-feedback"
                      i18n="@@profile-page.profileOnlyLatinCharAllowed"
                    >
                      Only latin characters allowed
                    </div>
                  </ng-container>
                </div>

                <div class="mb-7 with-text-tip col-md-4 col-sm-6 col-12">
                  <label for="lastName"
                         class="form-label">
                    <span i18n="@@profile-page.profileFormLastName">Last name</span>
                    <span class="mandatory-indicator" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    formControlName="lastname"
                    class="form-control"
                    [class.is-invalid]="showValidation && profileForm.get('lastname').errors"
                    maxlength="50"
                  />
                  <ng-container *ngIf="showValidation && profileForm.get('lastname').errors">
                    <div
                      *ngIf="profileForm.get('lastname').errors.required"
                      class="invalid-feedback"
                      i18n="@@profile-page.profileMustBeNotEmpty"
                    >
                      Please fill in required field
                    </div>
                    <div
                      *ngIf="profileForm.get('lastname').value.length"
                      class="invalid-feedback"
                      i18n="@@profile-page.profileOnlyLatinCharAllowed"
                    >
                      Only latin characters allowed
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="row">
                <ng-container *ngIf="profileConfig.local_names_enabled">
                  <div class="mb-7 col-md-4 col-sm-6 col-12">
                    <label for="firstname_local"
                           class="form-label"
                           i18n="@@profile-page.profileFormFirstNameLocal">
                      First name (local)
                    </label>
                    <input
                      type="text"
                      id="firstname_local"
                      formControlName="firstname_local"
                      class="form-control"
                      maxlength="50"
                    />
                  </div>

                  <div class="mb-7 col-md-4 col-sm-6 col-12">
                    <label for="lastname_local"
                           class="form-label"
                           i18n="@@profile-page.profileFormLastNameLocal">
                      Last name (local)
                    </label>
                    <input
                      type="text"
                      id="lastname_local"
                      formControlName="lastname_local"
                      class="form-control"
                      maxlength="50"
                    />
                  </div>
                </ng-container>
              </div>

              <div class="row">
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="jobPosition"
                         class="form-label"
                         i18n="@@profile-page.profileFormJobPosition">
                    Job position
                  </label>
                  <ng-select
                    id="jobPosition"
                    [virtualScroll]="true"
                    [searchable]="false"
                    [clearable]="false"
                    [items]="jobPositions"
                    bindLabel="label"
                    bindValue="value"
                    formControlName="job_position"
                  >
                  </ng-select>
                </div>

                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="job_area"
                         class="form-label"
                         i18n="@@profile-page.profileFormJobArea">
                    Job area
                  </label>
                  <ng-select
                    id="job_area"
                    [virtualScroll]="true"
                    [searchable]="false"
                    [clearable]="false"
                    [items]="jobAreas"
                    bindLabel="label"
                    bindValue="value"
                    formControlName="job_area"
                  >
                  </ng-select>
                </div>

                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="preferredLanguage"
                         class="form-label"
                         i18n="@@profile-page.profileFormPreferredLanguage">
                         Preferred language
                  </label>
                  <ng-select
                    id="preferredLanguage"
                    [searchable]="false"
                    [clearable]="false"
                    [items]="preferredLanguages"
                    bindLabel="label"
                    bindValue="value"
                    formControlName="store_id"
                  >
                  </ng-select>
                </div>
              </div>

              <div class="row">
                <ng-container *ngIf="customer.customerConfig?.is_decision_maker">
                  <div class="mb-7 col-md-4 col-sm-6 col-12">
                    <label for="primaryBusiness" i18n="@@profile-page.landingPrimaryBusiness">
                      Primary business
                      <ng-template #htmlContent>
                        <div [innerHTML]="profileConfig.primary_business_message"></div>
                      </ng-template>

                      <ng-container *ngIf="profileConfig.primary_business_message.length > 0">
                        <i class="tip" [ngbTooltip]="htmlContent" data-placement="top" container="body"></i>
                      </ng-container>
                    </label>
                    <ng-select
                      id="primaryBusiness"
                      [searchable]="false"
                      [clearable]="false"
                      [items]="primaryBusinesses"
                      bindLabel="label"
                      bindValue="value"
                      formControlName="primary_business_option"
                    >
                    </ng-select>
                  </div>

                  <div class="mb-7 col-md-4 col-sm-6 col-12">
                    <div class="d-inline-flex">
                    <label for="timezone">
                      <span i18n="@@profile-page.profileFormTimezone">Time Zone</span>
                      <span class="mandatory-indicator" aria-hidden="true">*</span>
                    </label>
                    </div>
                    <ng-select
                      id="timezone"
                      [virtualScroll]="true"
                      [searchable]="false"
                      [clearable]="false"
                      [items]="timezones"
                      bindLabel="label"
                      bindValue="value"
                      (change)="processPlaceholders()"
                      [placeholder]="noTimeZonePlaceholder"
                      formControlName="timezone"
                      [ngClass]="showValidation && profileForm.get('timezone').invalid ? 'select-invalid' : ''"
                    >
                    </ng-select>
                    <div
                      *ngIf="showValidation && profileForm.get('timezone').errors"
                      class="invalid-feedback"
                      i18n="@@profile-page.selectOneOfTheOptions"
                    >
                      Please select one of the options
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="h5 you-are-administrator">
                {{ profileFormDecisionMakerString }}
                <ng-container *ngIf="customer.customerConfig?.is_decision_maker; else not_a_decisionMaker">
                  <strong i18n="@@profile-page.profileYes">Yes</strong>
                </ng-container>
                <ng-template #not_a_decisionMaker>
                  <strong i18n="@@profile-page.profileNo">No</strong>
                </ng-template>
              </div>

              <div class="divider"></div>

              <div class="row">
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="contactEmail"
                         class="form-label">
                    <span i18n="@@profile-page.profileFormEMail">Please enter your contact email</span>
                    <span class="mandatory-indicator" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="text"
                    id="contactEmail"
                    formControlName="contact_email"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid': profileForm.get('contact_email').errors && profileForm.get('contact_email').dirty
                    }"
                    maxlength="100"
                  />
                  <div
                    *ngIf="profileForm.get('contact_email').errors"
                    class="invalid-feedback"
                    i18n="@@profile-page.profileInvalidEmail"
                  >
                    Please provide valid email address
                  </div>
                </div>

                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="phoneWork"
                         class="form-label">
                    <span i18n="@@profile-page.profileFormWorkPhoneNumber">Work phone number</span>
                    <span class="mandatory-indicator" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="text"
                    id="phoneWork"
                    formControlName="work_phone_number"
                    class="form-control"
                    [placeholder]="profilePhoneNumberPlaceholder"
                    [ngClass]="showValidation && profileForm.get('work_phone_number').errors ? 'is-invalid' : ''"
                    maxlength="20"
                  />
                  <div
                    *ngIf="showValidation && profileForm.get('work_phone_number').errors"
                    class="invalid-feedback"
                    i18n="@@profile-page.profileInvalidPhoneNumber"
                  >
                    Invalid Phone number
                  </div>
                </div>

                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="phoneMobile"
                         class="form-label"
                         i18n="@@profile-page.profileFormMobilePhoneNumber">
                    Cell phone number</label>
                  <input
                    type="text"
                    id="phoneMobile"
                    formControlName="mobile_phone_number"
                    class="form-control"
                    [ngClass]="{
                      'is-invalid':
                        profileForm.get('mobile_phone_number').errors && profileForm.get('mobile_phone_number').dirty
                    }"
                    maxlength="20"
                  />
                  <div
                    *ngIf="profileForm.get('mobile_phone_number').errors"
                    class="invalid-feedback"
                    i18n="@@profile-page.profileInvalidPhoneNumber"
                  >
                    Invalid Phone number
                  </div>
                </div>
              </div>

              <div class="divider"></div>

              <div class="row">
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="amadeusOffice"
                         class="form-label"
                         i18n="@@profile-page.profileFormAmadeusOffice">Amadeus office</label>
                  <input type="text"
                         id="amadeusOffice"
                         formControlName="office_id"
                         class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="street"
                         class="form-label"
                         i18n="@@profile-page.profileFormAddress">Address</label>
                  <input type="text"
                         id="street"
                         formControlName="street"
                         class="form-control" />
                </div>
              
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="city"
                         class="form-label"
                         i18n="@@profile-page.profileFormCity">City</label>
                  <input type="text"
                         id="city"
                         formControlName="city"
                         class="form-control" />
                </div>
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="zipCode"
                         class="form-label"
                         i18n="@@profile-page.profileFormZipCode">ZIP code</label>
                  <input type="text"
                         id="zipCode"
                         formControlName="postal_code"
                         class="form-control" />
                </div>
              </div>
              
              <div class="row">
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="province"
                         class="form-label"
                         i18n="@@profile-page.profileFormState">State</label>
                  <input type="text"
                         id="province"
                         formControlName="province"
                         class="form-control" />
                </div>
              
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <label for="country"
                         class="form-label"
                         i18n="@@profile-page.profileFormCountry">Country</label>
                  <input type="text"
                         id="country"
                         formControlName="country"
                         class="form-control" />
                </div>
              </div>

              <div class="row">
                <div class="mb-7 col-md-4 col-sm-6 col-12">
                  <div style="padding-bottom: 15px;">
                    <span class="mandatory-indicator" aria-hidden="true">*</span>
                    <span i18n="@@profile-page.mandatoryFields">Mandatory fields</span>
                  </div>
                </div>
              </div>

              <div class="form-footer">
                <div class="form-check">
                  <input
                    type="checkbox"
                    id="marketingEmailAllowed"
                    formControlName="marketing_email_allowed"
                    class="form-check-input"
                  />
                  <label class="form-check-label"
                         for="marketingEmailAllowed"
                         i18n="@@profile-page.profileFormPersonalizedOffers">
                    I wish to receive personalized offers
                  </label>
                </div>

                <button
                  type="submit"
                  class="btn btn-primary big save-changes"
                  (click)="onSubmit()"
                  i18n="@@profile-page.profileFormButton"
                >
                  Save changes
                </button>
              </div>
            </div>
          </form>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
